/** @jsx jsx */
import React, { useMemo, type ReactNode } from 'react';
import { css, jsx } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import { token } from '@atlaskit/tokens';
import { Tokens } from '@atlassian/jira-custom-theme-constants/src/constants.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import InviteButton from '@atlassian/jira-onboarding/src/ui/invite-button/view/index.tsx';
import type { NavigationInviteButton_project$key } from '@atlassian/jira-relay/src/__generated__/NavigationInviteButton_project.graphql';

type NavigationInviteButtonProps = {
	scope: 'project' | 'board';
	projectFragment: NavigationInviteButton_project$key | null;
};

export const NavigationInviteButton = ({ scope, projectFragment }: NavigationInviteButtonProps) => {
	const project = useFragment(
		graphql`
			fragment NavigationInviteButton_project on JiraProject {
				name
				key
				projectId
			}
		`,
		projectFragment,
	);

	const attributes = useMemo(() => ({ scope }), [scope]);

	return (
		project && (
			<ContextualAnalyticsData sourceName="horizontal-nav-header" attributes={attributes}>
				<CustomWrapper>
					<InviteButton
						projectKey={project.key}
						projectName={project.name}
						projectId={Number(project.projectId)}
					/>
				</CustomWrapper>
			</ContextualAnalyticsData>
		)
	);
};

const CustomWrapper = ({ children }: { children: ReactNode }) => (
	<div css={wrapperStyle}>{children}</div>
);

const wrapperStyle = css({
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	'--ds-border': Tokens.COLOR_BORDER,
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	'--ds-text-subtle': Tokens.COLOR_TEXT_SUBTLE,
	marginRight: token('space.075'),
});
